import { combineReducers } from "redux";
import authReducer from "./auth_reducer";
import phoneSystemReducer from "./phone_sytem_reducer";

export default combineReducers({
    auth: authReducer,
    phoneSystem: phoneSystemReducer,
});
